import { FaultTypeOption } from 'pages/Desk/issues/fault_type/FaultTypesInput';
import { memo } from 'react';
import { Lozenge } from 'shared/lozenge/Lozenge';
import { KCFColor } from 'styles/themes/KCFColor';

export type FaultTypeLozengeProps = Readonly<{
    faultType: FaultTypeOption;
    onRemove?: () => void;
}>;

function FaultTypeLozenge({ faultType, onRemove }: FaultTypeLozengeProps) {
    return (
        <Lozenge
            backgroundColor={KCFColor.lightGrey4}
            color={KCFColor.multiselectLozengeText}
            onRemove={onRemove}
        >
            {faultType.FullName}
        </Lozenge>
    );
}

const memoFaultTypeLozenge = memo(FaultTypeLozenge);
export { memoFaultTypeLozenge as FaultTypeLozenge };
